// Nombres que ve el usuario para los códigos que devuelve /b2c-report-v2.
// Siguen los nombres que Guille pidió para MRR Resumen (spec 091): "B2C by Brokers",
// "B2B2C por Planilla".

export const SEGMENT_LABELS = {
  b2cDirect: 'B2C Directo',
  b2cBrokers: 'B2C by Brokers',
  b2b2cDirectPay: 'B2B2C Pago Directo',
  b2b2cPayroll: 'B2B2C por Planilla'
};

export const CHANNEL_LABELS = {
  app: 'App',
  felix: 'Felix',
  dedicatedFelix: 'Felix del broker',
  brokerSite: 'Sitio del broker',
  companyAgreement: 'Convenio de empresa',
  unknown: 'Sin dato'
};

export const COUNTRY_OPTIONS = [
  { text: 'Todos', value: null },
  { text: 'Chile', value: 'CL' },
  { text: 'Perú', value: 'PE' },
  { text: 'México', value: 'MX' }
];
